module.exports = __webpack_public_path__ + "static/img/background.a5b50644.svg";